import React from 'react'

import styled, {css} from 'styled-components'

const HoverButtonWrapper = styled.button`
  color: ${props=> props.textColor}
  text-align: left;
  padding: 19px
  
  :hover {
    background: ${props=> props.secondary}
  }
  
  ${props => props.active && css`
    color: ${props.secondaryTextColor}
    background: ${props=> props.secondary}
  `}
`
export function HoverButton({campaign, ...rest}) {
  return (
    <HoverButtonWrapper 
      {...extractCampaignInfo(campaign)}
      {...rest}
    />
  )
}

//utility function to capture campaing information
const extractCampaignInfo = (campaign) => {
  const colors = campaign.template && campaign.template.appearence && campaign.template.appearence.colors
  return {
    primary: colors && colors["brand-default"],
    secondary: colors && colors["brand-hover"],
    textColor: colors && colors["text-tertiary"]
  }
}
